/**
 * Format a number as currency (ZAR)
 * @param value - The number to format
 * @returns Formatted currency string
 */
export const formatCurrency = (value: number): string => {
  return value.toLocaleString('en-ZA', {
    style: 'currency',
    currency: 'ZAR'
  });
};

/**
 * Format a date string to a localized date format
 * @param dateString - The date string to format
 * @returns Formatted date string
 */
export const formatDate = (dateString?: string): string => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-ZA');
};

export const toDateInputValue = (dateString?: string): string => {
  if (!dateString) return '';

  const parsedDate = new Date(dateString);
  if (Number.isNaN(parsedDate.getTime())) return '';

  const year = parsedDate.getFullYear();
  const month = `${parsedDate.getMonth() + 1}`.padStart(2, '0');
  const day = `${parsedDate.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getPreferredDateInputValue = (preferredDate?: string, fallbackDate?: string): string => {
  return toDateInputValue(preferredDate) || toDateInputValue(fallbackDate);
};

export const formatDateTime = (dateString?: string): string => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString('en-ZA', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false,
  });
};